
import { Field, reduxForm } from 'redux-form';
import { isValidNameWithSpace, renderCheckBox, renderTextField } from '../../../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import { saveClearingHouseData, getClearingHouseDetails } from './actions/ClearingHouseActions';
import validate from './validate';
import { CommonButton } from '../../../../components/buttons';
import { checkFieldExistence, clearFieldErrorArray } from '../../../AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { EBS, STEPUPOUTPATIENT } from '../../../../actions/utilAction';
import SmallLoader from '../../../../img/small-loader.gif';

class ClearingHouseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clearingHouseId: props.clearingHouseId,
      open: true,
    };
  }

  componentWillMount() {
    if (this.state.clearingHouseId) {
      this.props.getClearingHouseDetails(this.state.clearingHouseId);
    }
  }

  componentWillReceiveProps(nextProps) {
    // on ESC key press close Dailog ...
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }
  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.clearFieldErrorArray();
      this.props.closeDialog();
    }
  };


  handleSave=(formProps) => {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formProps.id = this.state.clearingHouseId;
    this.props.clearFieldErrorArray();
    this.props.saveClearingHouseData(formProps);
    this.setState({ open: false });
    this.props.closeDialog();
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.clearingHouseId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <CommonButton label="Saving" className="loader_btn" primary={true} disabled = {true}/> : <CommonButton label="Save" type="submit" primary={true} onTouchTap={handleSubmit(this.handleSave.bind(this))} />;
    const actions = [
      <CommonButton
        className= 'mr-15 grey_btn' label="Cancel" onTouchTap={this.handleClose}/>,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={(this.state.clearingHouseId) ? 'Edit Clearing House' : 'Add Clearing House'}
          modal={false}
          actions={actions}
          open={this.state.open}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form" noValidate >
                <div className="row">
                  <div className="col-sm-4 require">
                    <Field
                      autoFocus={true}
                      name="clearingHouseName"
                      label="Clearing House Name"
                      //onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Name')}
                      //customError={displayCustomError('CLEARINGHOUSENAME', this.props.fieldError)}
                      normalize = {isValidNameWithSpace}
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-4 require">

                    <Field
                      name="senderID"
                      label="Sender Id"
                      normalize = {isValidNameWithSpace}
                      component={renderTextField}
                    />
                  </div>

                  <div className="col-sm-4 require">

                    <Field
                      name="receiverID"
                      label="Receiver Id"
                      normalize = {isValidNameWithSpace}
                      component={renderTextField}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 require">

                    <Field
                      name="interchangeQualifier"
                      label="Interchange QLFR"

                      component={renderTextField}
                      maxLength ={5}
                    />
                  </div>

                  <div className="col-sm-4 require">
                    <Field
                      name="ftpurl"
                      label="FTP URL"

                      component={renderTextField}
                    />
                  </div>

                  <div className="col-sm-4 require">
                    <Field
                      name="portNo"
                      label="FTP Port"
                      component={renderTextField}
                      maxLength ={5}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 require">
                    <Field
                      name="path837"
                      label="837 Folder"
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-6 require">
                    <Field
                      name="path835"
                      label="835 Folder"
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field
                      name="path999"
                      label="999 Folder"
                      component={renderTextField}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field
                      name="path277"
                      label="277 Folder"
                      component={renderTextField}
                    />
                  </div>
                 {this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === STEPUPOUTPATIENT ? 
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="isMasterAccount"
                      label="Is Master Account"
                      component={renderCheckBox}
                    />
                  </div>
                  :null} 
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

ClearingHouseModal = reduxForm({
  form: 'ClearingHouseModalForm',
  validate,
  enableReinitialize: true,
})(ClearingHouseModal);

function mapStateToProps(state, ownProps) {
  let initialValuesData = null;
  if (ownProps.clearingHouseId && state.superAdminClearingHouse.clearingHouseDetails) {
    let clearinghouseData = state.superAdminClearingHouse.clearingHouseDetails.data;
    initialValuesData = {
      ...clearinghouseData,
    };
  }
  return {
    loading: state.superAdminClearingHouse.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValuesData,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveClearingHouseData, getClearingHouseDetails })(ClearingHouseModal);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/clearing-house/clearing-house-modal.js